import { createContext, useContext } from 'react';

// [Interrupteur Sentinel] Réglages publics du site diffusés à toute l'app (lus depuis GET /api/settings).
// Aujourd'hui limité au flag d'ouverture de Sentinel ; peut s'étendre à d'autres réglages publics.
export interface PublicSiteSettings {
    // false = Sentinel fermé : promotion masquée, entrées Sentinel masquées aux visiteurs anonymes,
    // inscriptions bloquées (barrière serveur). Les comptes connectés gardent l'accès à l'outil.
    sentinelPublic: boolean;
    // false tant que l'état d'ouverture n'est ni mémorisé ni reçu de /api/settings : à tester avant
    // toute redirection ou tout message « fermé », sinon un nouveau visiteur les subit à tort.
    settingsLoaded: boolean;
}

// Défaut FERMÉ : tant que /api/settings n'est pas résolu, on masque la promo Sentinel (côté sûr —
// on ne veut jamais flasher la promo sur un site fermé). App.tsx fournit la valeur réelle.
export const SiteSettingsContext = createContext<PublicSiteSettings>({ sentinelPublic: false, settingsLoaded: false });

export const useSiteSettings = () => useContext(SiteSettingsContext);
